if (!window.Eurus.loadedScript.has('cart-upsell-scroll.js')) {
  window.Eurus.loadedScript.add('cart-upsell-scroll.js');

  // No requestAnimationFrame wrapper here (unlike most theme scripts): rAF never
  // fires while a tab is backgrounded, which would silently skip registering the
  // listener. There is nothing to paint at registration time, so it is not needed.
  {
    // On the cart page the drawer is not rendered at all (cart-drawer is wrapped in
    // `unless template == 'cart'`), so adding from the "S-ar putea să-ți placă"
    // upsell gave no visible feedback — the new line appears far above the fold.
    // Scroll it into view instead.
    //
    // The cart section re-renders asynchronously after the add, so the row does not
    // exist yet when the event fires: poll briefly for it rather than guess a delay.
    const MAX_WAIT = 3000;
    const STEP = 80;

    const variantIdsFrom = (detail) => {
      const raw = detail && detail.product;
      if (!raw) return [];
      const items = Array.isArray(raw) ? raw : [raw];
      return items.map((i) => String(i.variant_id || i.id || '')).filter(Boolean);
    };

    const findRow = (variantId) => {
      // Cart line keys are "<variantId>:<hash>", exposed on the quantity input id.
      const input = document.querySelector('[id^="cart-qty-' + variantId + ':"]');
      return input ? input.closest('tr, li, .cart-item') : null;
    };

    document.addEventListener('eurus:product:added', (e) => {
      if (!document.getElementById('main-cart-items')) return;

      const ids = variantIdsFrom(e.detail);
      if (!ids.length) return;

      const deadline = Date.now() + MAX_WAIT;
      const attempt = () => {
        // Last added wins, so the customer lands on what they just chose.
        for (let i = ids.length - 1; i >= 0; i -= 1) {
          const row = findRow(ids[i]);
          if (row) {
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
        if (Date.now() < deadline) setTimeout(attempt, STEP);
      };
      setTimeout(attempt, STEP);
    });
  }
}
